module.exports = __webpack_public_path__ + "img/step_1.fc60113d.webp";